import { getAsync } from '../helpers/apiRequest'
import { IBodyRequestModel } from '../models/api/IBodyRequestModel'
import { TokenExpiryWrapper } from './TokenManager'

export interface IGISQueryRequest extends IBodyRequestModel {
  layer: 'ARCGIS_INSPECTION_COMMS_LAYER' | 'ARCGIS_SW_LAND_LOT_COVERAGE_LAYER'
  property_number?: string
  objectid?: string
  spatial_reference?: string
}

export interface IGISQueryResponse {
  success: boolean
  message?: string
  // eslint-disable-next-line
  data?: any
}

export const gisLayer = TokenExpiryWrapper(
  async (request: IGISQueryRequest): Promise<IGISQueryResponse> => {
    const url = `/gis/layer/${request.layer}`
    return await getAsync(url, request)
  },
  [],
  null,
)

export const gisQuery = TokenExpiryWrapper(
  async (request: IGISQueryRequest): Promise<IGISQueryResponse> => {
    const url = `/gis/query/${request.layer}?property_number=${request.property_number}&spatial_reference=${request.spatial_reference}`
    return await getAsync(url, request)
  },
  [],
  null,
)

export const gisUpdate = TokenExpiryWrapper(
  async (request: IGISQueryRequest): Promise<IGISQueryResponse> => {
    const url = `/gis/update/${request.layer}/${request.objectid}`
    return await getAsync(url, request)
  },
  [],
  null,
)

export const gisAdd = TokenExpiryWrapper(
  async (request: IGISQueryRequest): Promise<IGISQueryResponse> => {
    const url = `/gis/add/${request.layer}?property_number=${request.property_number}`
    return await getAsync(url, request)
  },
  [],
  null,
)

export const gisDelete = TokenExpiryWrapper(
  async (request: IGISQueryRequest): Promise<IGISQueryResponse> => {
    const url = `/gis/delete/${request.layer}?objectid=${request.objectid}`
    return await getAsync(url, request)
  },
  [],
  null,
)
